import { useCallback, useMemo, useState } from "react";
import { usePlatformDesigner } from "@/lib/usePlatformDesigner";
import { useEntitlements } from "@/modules/useEntitlements";
import { resolveHubModuleAccess } from "@/modules/moduleAccess";

/**
 * Acceso a módulo para UI — entitlements + is_platform_designer (backend).
 * Fase 2: useEntitlements delega en useCapabilities cuando hay respuesta disponible.
 *
 * TODO FASE 3: consumir useCapabilities directamente.
 * @param {string} moduleId - WORK_MODULES.* o HUB_TRAMITES
 */
export function useModuleAccess(moduleId) {
  const isPlatformDesigner = usePlatformDesigner();
  const ent = useEntitlements();
  const [planBlockedOpen, setPlanBlockedOpen] = useState(false);

  const accessCtx = useMemo(
    () => ({
      isPlatformDesigner,
      permLoading: ent.loading,
      modulo_visor_sat: ent.modulo_visor_sat,
      modulo_asistente_laboral: ent.modulo_asistente_laboral,
      modulo_tramites_fiscales: ent.modulo_tramites_fiscales,
      modulo_gestion_despacho: ent.modulo_gestion_despacho,
      entitlements: ent.entitlements,
    }),
    [isPlatformDesigner, ent],
  );

  const hasModuleAccess = useMemo(
    () => resolveHubModuleAccess(moduleId, accessCtx),
    [moduleId, accessCtx],
  );

  const guardCriticalAction = useCallback(
    (action) => {
      if (ent.loading || hasModuleAccess == null) return false;
      if (hasModuleAccess) {
        action();
        return true;
      }
      setPlanBlockedOpen(true);
      return false;
    },
    [hasModuleAccess, ent.loading],
  );

  return {
    hasModuleAccess,
    accessLoading: ent.loading,
    guardCriticalAction,
    planBlockedOpen,
    setPlanBlockedOpen,
    permissions: ent,
    entitlements: ent.entitlements,
    hasEntitlement: ent.hasEntitlement,
    isPlatformDesigner,
  };
}

export { useEntitlements, invalidateEntitlementsCache } from "@/modules/useEntitlements";
